import styled from "styled-components";

export const Styled = styled.div`
  .display-size-container {
    border: none;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #d9dde5;
    padding: 2px 8px;
    border-radius: 4px;
  }
  .display-size__divider {
    display: none;
  }
  .display-size__radio-group {
    .ant-radio-button-wrapper {
      background: #d9dde5;
    }
    .ant-radio-button-checked {
      background: #1e3665 !important;
      border-radius: 4px;
    }
  }
  .ant-radio-button-wrapper {
    padding: 0 0px 0px 4px;
    height: 24px;
    width: 24px;
    line-height: 24px;
    font-size: 16px;
    background: transparent;
    transition: all 0.1s ease;
  }
  .ant-radio-button-wrapper:not(:last-child) {
    margin-right: 5px;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none !important;
  }
  .ant-radio-button-wrapper-checked {
    border: none !important;
    background: transparent;
    color: #fff;
    font-weight: 700;
  }
`;
